import * as React from "react"
import { observer } from "mobx-react"
import ToggleSwitch from "../../components/ToggleSwitch"
import { Flex } from "rebass"
import { Member } from "BookingSystem/db/Member"
import { SessionEditor } from "./SessionEditor"

@observer
export class PassesMemberPicker extends React.Component<{
  model: SessionEditor
}> {
  render() {
    const { model } = this.props
    const { memberList, isSelectable } = model

    return (
      <Flex
        id="PassesMemberPicker"
        flexDirection={["column"]}
        style={{ textTransform: "uppercase", width: "100%" }}
      >
        <Flex style={{ borderBottom: "solid 1px rgba(255,255,255, 0.1)" }}>
          {isSelectable ? (
            <Flex justifyContent="center" alignItems="center" width={[0.16]} />
          ) : (
            <Flex />
          )}
        </Flex>
        <Flex id="member-list" flexDirection="column">
          {memberList.map((member: Member, i) => (
            <Flex
              key={i}
              className="member-list-item"
              width={[1]}
              style={{
                fontSize: window.innerWidth > 600 ? 18 : 14
              }}
            >
              {isSelectable && (
                <Flex alignItems="center" width={[0.1]}>
                  <ToggleSwitch
                    type="checkbox"
                    className="toggle"
                    checked={model.has(member)}
                    onChange={() => {
                      if (model.sessionGroup.session.capacityLeft > 0) {
                        model.toggleMembership(member)
                      } else {
                        alert(
                          "Your group number currently exceed the capacity for this activity at this time."
                        )
                      }
                    }}
                  />
                </Flex>
              )}
              <Flex alignItems="center" width={[0.9]} p={["0.5rem", "0.75rem"]}>
                {member.shortName}
              </Flex>
            </Flex>
          ))}
        </Flex>
      </Flex>
    )
  }
}
